import { IAccount } from '../../../../../models';

export function formatOption(title?: string, accountNo?: string) {
    return (
        <span className='account-select-option'>
            <h4 className='account-select-option--header xui-margin-top-2xsmall'>{title}</h4>
            <p className='xui-text-secondary account-select-option--body xui-margin-bottom-2xsmall'>{accountNo}</p>
        </span>
    );
}

export function isClearingAccountMissing(clearingAccount?: IAccount, bankAccount?: IAccount) {
    return (
        (clearingAccount === null || clearingAccount === undefined) && bankAccount !== null && bankAccount !== undefined
    );
}
